import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const Company = (props) => {
  const weekdayNames = [];
  const openingHoursList = [];

  moment.locale(drupalSettings.path.currentLanguage);
  const date = moment();

  for (let i = 0; i < 6; i++) {
    const dateFormatted = date.format('YYYY-MM-DD');
    const dayFormatted = date.format('ddd');

    weekdayNames.push(
      <div key={i} className="opening-hours-company__date">
        <div>{dayFormatted}</div>
        <div>{date.format('D.M')}</div>
      </div>,
    );

    let hours;
    if (props.openingHours[dateFormatted]) {
      hours = (
        <span>
          {formatTime(props.openingHours[dateFormatted].open)}-
          {formatTime(props.openingHours[dateFormatted].close)}
        </span>
      );
    } else {
      hours = <span>{Drupal.t('Closed')}</span>;
    }

    date.add(1, 'day');

    openingHoursList.push(
      <div key={i} className="opening-hours-company__hours">
        {hours}
      </div>,
    );
  }

  // Formats the time. Shows minutes only if they're not zero.
  function formatTime(time) {
    const times = [time.substring(0, 2), time.substring(2, 4)];
    let formattedTime = times[0];

    if (times[1] !== '00') {
      formattedTime += `:${times[1]}`;
    }

    return formattedTime;
  }

  return (
    <div className="opening-hours-company">
      <div className="opening-hours-company__details-wrapper">
        <div className="opening-hours-company__details-title">
          {props.title}
        </div>
        {props.website && (
          <a
            className="opening-hours-company__details opening-hours-company__details--website"
            href={props.website}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="visually-hidden">{Drupal.t('Home page')}</span>
          </a>
        )}
        {props.map && (
          <a
            className="opening-hours-company__details opening-hours-company__details--map"
            href={props.map}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="visually-hidden">{Drupal.t('Map')}</span>
          </a>
        )}
      </div>
      <div className="opening-hours-company__date-wrapper">{weekdayNames}</div>
      <div className="opening-hours-company__hours-wrapper">
        {openingHoursList}
      </div>
    </div>
  );
};

Company.propTypes = {
  title: PropTypes.string,
  website: PropTypes.string,
  map: PropTypes.string,
  openingHours: PropTypes.object,
};

export default Company;
